module.exports = __webpack_public_path__ + "img/m-wash4-front.c65c98af.jpg";